// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--L1ZnK","navBar":"header-module--navBar--1SLmY","logo":"header-module--logo--3jDIS"};